$(document).ready(function(){
	//$('.js_customer-code').on('keyup', syncCustomer)
	$('.js_contact_id').select2()
});
